var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.792,
    height: 13.199,
    viewBox: "4008.186 5464.001 13.792 13.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4014.342 5464.46-1.683 3.413-3.766.549a.825.825 0 0 0-.457 1.407l2.725 2.656-.644 3.75a.824.824 0 0 0 1.196.869l3.369-1.771 3.37 1.771a.825.825 0 0 0 1.195-.869l-.644-3.75 2.725-2.656a.825.825 0 0 0-.457-1.407l-3.766-.55-1.683-3.412a.826.826 0 0 0-1.48 0Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "Icon awesome-star"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/StarIcon.818fb90e244ff60ed960f145d9cd568b.svg";
export { ForwardRef as ReactComponent };